import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { useM2, fmtM2 } from "@/lib/stats";

export default function AboutUs() {
  const m2 = fmtM2(useM2());
  return (
    <section id="o-nas" className="bg-ink py-24 md:py-36 border-t border-white/10" data-testid="about-us">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          {/* Photo */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="md:col-span-5"
          >
            <div className="relative">
              <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
                <img
                  src="/founder-jan-mika.jpg"
                  alt="Ján Mika — zakladateľ Zateplenia.eu"
                  className="w-full h-full object-cover"
                  data-testid="founder-photo"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
              </div>
              {/* Badge */}
              <div className="absolute -bottom-5 -right-3 md:-right-6 bg-gold text-ink px-5 py-4 shadow-xl">
                <div className="font-display text-4xl md:text-5xl leading-none">20</div>
                <div className="font-mono2 text-[10px] uppercase tracking-widest mt-1">rokov skúseností</div>
              </div>
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="md:col-span-7"
          >
            <p className="font-mono2 text-gold uppercase tracking-[0.3em] text-xs mb-5">O nás</p>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.92] text-white">
              20 rokov s Vami<br /><span className="text-gold">od roku 2006</span>
            </h2>
            <div className="mt-8 space-y-5 text-white/65 text-base md:text-lg leading-relaxed max-w-2xl">
              <p>
                Zatepľovaniu fasád sa venujeme už od roku 2006. Za ten čas sme zateplili viac ako
                <span className="text-white font-semibold"> {m2} m²</span> fasád rodinných domov,
                bytových domov aj väčších budov po celom Slovensku.
              </p>
              <p>
                Vieme, že zateplenie je investícia na desiatky rokov — preto staviame na kvalitných
                materiáloch, precíznej práci a férovej, transparentnej cene. Žiadne skryté poplatky,
                žiadne prekvapenia. Len poctivo odvedená práca, na ktorú dávame záruku.
              </p>
            </div>

            <div className="mt-8 flex items-center gap-4 border-t border-white/10 pt-6">
              <div>
                <div className="font-display text-2xl text-white leading-none">Ján Mika</div>
                <div className="font-mono2 text-gold text-xs uppercase tracking-widest mt-1">Zakladateľ</div>
              </div>
              <div className="ml-auto flex items-center gap-2 text-white/50 text-sm">
                <ShieldCheck className="w-5 h-5 text-gold" />
                Záruka 36 / 60 mesiacov
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
